import * as React from 'react';

import { cn } from '@/lib/cn';

/**
 * Height + opacity fold shared by `Disclosure` and the collapsible sidebar
 * section. The row track goes `0fr` <-> `1fr`, so the real height animates
 * without measuring; the content stays mounted but `inert` and invisible while
 * closed (no focus, no screen reader). Durations come from the kit tokens
 * (`--dur-2`, `--ease-out` in, `--ease-in` out); under reduced motion they are
 * 0, outside the kit scope they are unset, so it just toggles.
 */
export function Collapse({
  open,
  id,
  className,
  children,
}: {
  open: boolean;
  id?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      id={id}
      data-slot="collapse"
      data-state={open ? 'open' : 'closed'}
      inert={!open}
      className={cn(
        'grid transition-[grid-template-rows,opacity,visibility] duration-(--dur-2)',
        open ? 'ease-(--ease-out) grid-rows-[1fr] opacity-100' : 'invisible grid-rows-[0fr] opacity-0 ease-(--ease-in)',
      )}
    >
      {/* The clipping box has no padding of its own: padding would keep the closed row open. */}
      <div className="min-h-0 overflow-hidden">
        <div className={className}>{children}</div>
      </div>
    </div>
  );
}
